import { lazyLoad } from '@/lib/LazyLoad';

export const SignInPage = lazyLoad(
  () => import('./SignIn'),
  (module) => module.SignIn
);
